import { Deserializable } from '../../protocols/deserializable';

export class ProfileBadgeConfiguration implements Deserializable {
  id!: number;
  name: string = '';
  backgroundColour: string = '';
  borderColour: string = '';

  onDeserialize() {}
}
